import { userConstants } from './constantData';

export const HOME_DATA = {
  home: {
    page_view: {
      hash: 'p-002.001.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
  },
};
